import React from 'react'

const NotFoundPage = () => {
  return (
    <div className='text-center pt-10 '>Такой страницы не существует!!</div>
  )
}

export default NotFoundPage